import React from 'react';
import Text, { ITextProps } from '../animation/Text';

interface IHeadingTagProps extends ITextProps {
  data: {
    htag?: string;
    heading?: string;
  };
  children?: React.ReactNode;
}
const HeadingTag = ({ data, children, ...props }: IHeadingTagProps) => {
  const { htag, heading } = data || {};
  const polishedHeading = heading?.replace(/<(p|h[0-6])[^>]*>/g, '').replace(/<\/(p|h[0-6])>/g, '');
  let accessibilityLevel = 7;
  if (htag && parseInt(htag[1]) > 0) {
    accessibilityLevel = Number(htag[1]);
  }
  const content = polishedHeading ? { dangerouslySetInnerHTML: { __html: polishedHeading } } : { children };

  return (
    <Text tag={htag?.toLowerCase() || 'div'} role="heading" aria-level={accessibilityLevel} {...props} {...content} />
  );
};

HeadingTag.displayName = 'HeadingTag';

export default HeadingTag;
